<ion-header>
  <ion-toolbar mode="md">
    <ion-title>
      <ion-text *ngIf="order && order.order_id">#{{ order.order_id }}</ion-text>
      <ion-text *ngIf="order && order.short_order_id">
        ({{ order.short_order_id }})
      </ion-text>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button color="dark" fill="clear" (click)="closeModal()">
        <ion-icon slot="icon-only" src="assets/ionicons/close.svg"> </ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content scrollX="false" scrollY="false" [scrollEvents]="false">
  <ion-grid>
    <ion-row *ngIf="!order" class="ion-justify-content-center">
      <ion-col class="ion-text-center">
        <ion-spinner></ion-spinner>
      </ion-col>
    </ion-row>

    <ion-grid style="max-width: 250px">
      <ng-lottie [options]="cashierAnimationOptions"></ng-lottie>
    </ion-grid>

    <ion-item lines="none">
      <ion-label
        style="font-weight: bold"
        class="ion-text-center ion-text-wrap"
      >
        <ion-text>
          {{ "orders.order-item.please-complete-your-payment" | translate }}
        </ion-text>
      </ion-label>
    </ion-item>

    <ion-grid style="max-width: 280px">
      <ion-row
        [class]="
          !printBarcodeAlignment || printBarcodeAlignment === 'center'
            ? 'ion-text-center ion-justify-content-center'
            : printBarcodeAlignment === 'left'
            ? 'ion-text-start ion-justify-content-start'
            : 'ion-text-end ion-justify-content-end'
        "
        style="width: 100%; margin-top: 1em; margin-bottom: 1.5em"
      >
        <ngx-barcode
          [bc-value]="barcodeValue"
          [bc-format]="'CODE128'"
          [bc-display-value]="true"
        ></ngx-barcode>
      </ion-row>
    </ion-grid>
  </ion-grid>
</ion-content>

<ion-footer>
  <iong-grid style="margin-bottom: 20px">
    <ion-row>
      <ion-col class="ion-text-center">
        <ion-button
          *ngIf="hasAvailablePaymentGateway"
          color="danger"
          (click)="openChangePaymentMethod()"
        >
          {{ "orders.order-item.change-payment-method" | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
  </iong-grid>
</ion-footer>
